<template>
    <PageHeader :name="username" :is-admin="isAdmin">
        <template #home>
            <div>
                <DeviceTable :is-admin="isAdmin" :groups="groups"/>
            </div>
        </template>
        <template #usertools v-if="isAdmin">
            <div>
                <UserTools :users="users" :devices="devices" :groups="groups" @data-updated="updateData" />
            </div>
        </template>
        <template #grouptools v-if="isAdmin">
            <div>
                <GroupTools :users="users" :devices="devices" :groups="groups" @data-updated="updateData" />
            </div>
        </template>
        <template #devicetools v-if="isAdmin">
            <div>
                <DeviceTools :devices="devices" :groups="groups" @data-updated="updateData" />
            </div>
        </template>
        <template #userinfo>
            <div>
                <UserInfo v-if="user" :is-admin="isAdmin" :user="user" :groups="groups" />
            </div>
        </template>
    </PageHeader>
</template>

<script>
import { mapState } from 'vuex';
import PageHeader from './PageHeader.vue';
import DeviceTable from './DeviceTable.vue';
import UserTools from './UserTools.vue';
import DeviceTools from './DeviceTools.vue';
import GroupTools from './GroupTools.vue';
import UserInfo from './UserInfo.vue';
//const { getCookie } = require('@/helpers');
import { fetchData } from '@/helpers';

export default {
    name: 'HomePage',
    components: {
        PageHeader,
        DeviceTable,
        UserTools,
        DeviceTools,
        GroupTools,
        UserInfo
    },
    data() {
        return {
            users: [],
            groups: [],
            devices: [],
            isAdmin: false
        };
    },
    computed: {
        ...mapState({
            // isAdmin: state => state.isAdmin,
            username: state => state.username
        }),
        user() {
            return this.users.find(user => user.user_username === this.username);
        }
    },
    methods: {
        fetchData,
        async updateData() {
            if (this.isAdmin) {
                this.users = await this.fetchData('users');
                this.groups = await this.fetchData('groups');
                this.devices = await this.fetchData('devices');
            } else {
                this.users = await this.fetchData('users', { user_username: this.username });
                this.groups = await this.fetchData('groups');
                this.devices = await this.fetchData('devices');
            }
        }
    },
    async created() {
        this.isAdmin = await this.fetchData('admin');
        if (this.isAdmin) {
            this.users = await this.fetchData('users');
            this.groups = await this.fetchData('groups');
            this.devices = await this.fetchData('devices');
        } else {
            this.users = await this.fetchData('users', { user_username: this.username });
            this.groups = await this.fetchData('groups');
            this.devices = await this.fetchData('devices');
        }
    }
}
</script>

<style>
/* Add any custom styles here */
</style>